import { useSnackbar } from 'notistack';
import { useStores } from 'src/models';

export const useHandleResponse = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { responseStore } = useStores();

  return (successMessage: string, failMessage: string, onSuccess?: () => void) => {
    if (responseStore.responseInfo.resultCode === 'S') {
      enqueueSnackbar(successMessage, { variant: 'success' });
      onSuccess && onSuccess();
    } else {
      responseStore.responseInfo.errorCode!
        ? enqueueSnackbar(responseStore.responseInfo.errorMessage, { variant: 'error' })
        : enqueueSnackbar(failMessage, { variant: 'error' });
    }
  };
};
